import React from "react";
import {
  Modal,
  ModalBody,
  Button,
  ModalFooter,
  ModalHeader,
  Label,
} from "reactstrap";
import { LedgerPdfDataType } from "../../../screens/ClientSettings/CustomerSupplierManager";
import moment from "moment";
import DatePicker from "react-datepicker";
import { CalenderIcon } from "../../Icon";

type AppProps = {
  isOpen: boolean;
  handleLedgerStatementDownloadModal: () => void;
  handleDownloadLedgerStatementPdf: () => void;
  handleLedgerStatementPdfStartDate: (date: string) => void;
  handleLedgerStatementPdfEndDate: (date: string) => void;
  ledgerPdfData?: LedgerPdfDataType;
  ledgerPdfStartDate: string;
  ledgerPdfEndDate: string;
  ledgerPdfDownloadButton: boolean;
  ledgerType?: string;
};

const LedgerDownloadModal = ({
  isOpen,
  handleLedgerStatementDownloadModal,
  handleDownloadLedgerStatementPdf,
  handleLedgerStatementPdfStartDate,
  handleLedgerStatementPdfEndDate,
  ledgerPdfData,
  ledgerPdfEndDate,
  ledgerPdfStartDate,
  ledgerPdfDownloadButton,
  ledgerType,
}: AppProps) => {
  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={handleLedgerStatementDownloadModal}
        backdrop="static"
      >
        <ModalHeader>
          <span style={{ fontSize: "18px" }}>
            Download Statement for{" "}
            {ledgerPdfData ? ledgerPdfData?.legal_name : ledgerType}
          </span>
        </ModalHeader>
        <ModalBody style={{ paddingLeft: "40px" }}>
          <>
            <div className="d-flex">
              <div className="col-md-4 pl-0 pr-0 mr-5">
                <label className="mb-1" htmlFor="">
                  From <span className="color-red">*</span>
                </label>
                <div className="date-picker-wraper mr-0">
                  <Label className="m-0 p-0 w-100">
                    <DatePicker
                      dateFormat="dd-MM-yyyy"
                      onChange={(e: any) => {
                        handleLedgerStatementPdfStartDate?.(
                          moment(e).format("YYYY-MM-DD")
                        );
                      }}
                      selected={
                        ledgerPdfStartDate
                          ? new Date(
                              moment(
                                `${ledgerPdfStartDate}T00:00:00`,
                                "YYYY-MM-DD"
                              ).format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                      fixedHeight
                      showMonthDropdown
                      showYearDropdown
                      name="ledgerStatementPdfStartDate"
                      placeholderText="Start Date"
                      className="form-control pt-0 pb-0"
                    />
                    <span
                      className="calender-icon"
                      style={{ right: "10px", top: "35px", cursor: "pointer" }}
                    >
                      <CalenderIcon />
                    </span>
                  </Label>
                </div>
              </div>
              <div className="col-md-4 pl-0 pr-0">
                <label className="mb-1" htmlFor="">
                  To <span className="color-red">*</span>
                </label>
                <div className="date-picker-wraper mr-0">
                  <Label className="m-0 p-0 w-100">
                    <DatePicker
                      dateFormat="dd-MM-yyyy"
                      onChange={(e: any) => {
                        handleLedgerStatementPdfEndDate?.(
                          moment(e).format("YYYY-MM-DD")
                        );
                      }}
                      maxDate={
                        ledgerPdfStartDate
                          ? new Date(
                              moment(
                                `${ledgerPdfStartDate}T00:00:00`,
                                "YYYY-MM-DD"
                              )
                                .add(2, "months")
                                .format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                      selected={
                        ledgerPdfEndDate
                          ? new Date(
                              moment(
                                `${ledgerPdfEndDate}T00:00:00`,
                                "YYYY-MM-DD"
                              ).format("YYYY-MM-DD[T]HH:mm:ss")
                            )
                          : null
                      }
                      fixedHeight
                      showMonthDropdown
                      showYearDropdown
                      name="ledgerStatementPdfEndDate"
                      placeholderText="End Date"
                      className="form-control pt-0 pb-0"
                      disabled={!ledgerPdfStartDate?.length}
                      minDate={
                        new Date(
                          moment(
                            `${ledgerPdfStartDate}T00:00:00`,
                            "YYYY-MM-DD"
                          ).format("YYYY-MM-DD[T]HH:mm:ss")
                        )
                      }
                    />
                    <span
                      className="calender-icon"
                      style={{ right: "10px", top: "35px", cursor: "pointer" }}
                    >
                      <CalenderIcon />
                    </span>
                  </Label>
                </div>
              </div>
              <br />
            </div>
            <span className="text-danger mt-1" style={{ fontSize: "12px" }}>
              Note: Only 2-months data can be downloaded at once
            </span>
          </>
        </ModalBody>
        <ModalFooter>
          <span
            className="pointer"
            onClick={handleLedgerStatementDownloadModal}
          >
            Cancel
          </span>
          <Button
            color="primary ml-3"
            onClick={handleDownloadLedgerStatementPdf}
            disabled={
              !ledgerPdfEndDate ||
              !ledgerPdfStartDate ||
              ledgerPdfDownloadButton
            }
          >
            {ledgerPdfDownloadButton ? "Downloading..." : "Download"}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default LedgerDownloadModal;
